import { CHARACTER_FILTERS, CHARACTER_NAMES_EN } from '../lib/characters';
import { localeFromPath } from './routes';

// Le serveur répond en français ; sur /en, les messages connus sont traduits avant affichage.
const EXACT = {
  'Trop de tentatives, réessayez plus tard': 'Too many attempts, please try again later',
  'Email déjà utilisé': 'This email is already in use',
  'Email ou mot de passe incorrect': 'Incorrect email or password',
  'Non authentifié': 'Please sign in',
  'Token invalide': 'This link is invalid',
  'Token invalide ou expiré': 'This link is invalid or has expired',
  'Le mot de passe doit contenir au moins 12 caractères': 'Your password must contain at least 12 characters',
  'Le mot de passe est trop prévisible': 'This password is too easy to guess',
  'Paiement temporairement indisponible': 'Payment is temporarily unavailable',
  'Origine du paiement invalide': 'Invalid payment origin',
  "Paiement en cours de vérification, contactez l'atelier avant de réessayer": 'Your payment is being checked — please contact the workshop before trying again',
  'Une pièce ou matière vient de devenir indisponible': 'A piece or material has just become unavailable',
  'Stock insuffisant pour cette commande': 'Not enough stock for this order',
  "Tarif indisponible, contactez l'atelier": 'Price unavailable, please contact the workshop',
  'Produit introuvable': 'Product not found',
  'Commande introuvable': 'Order not found',
  'Confirmation en cours de vérification': 'Confirmation is being checked',
  'Vérification du paiement temporairement indisponible': 'Payment check is temporarily unavailable',
  'Vérification du paiement indisponible': 'Payment check unavailable',
  'Cette commande est déjà traitée ou en cours de vérification': 'This order has already been processed or is being checked',
  'Cette clé d\'idempotence correspond à une autre commande': 'This payment attempt belongs to another order — please reload the page',
  "Paiement incohérent, contactez l'atelier": 'Payment mismatch — please contact the workshop',
  'Aucune modification fournie': 'Nothing to update',
  'Nous ne livrons pas encore ce pays.': 'We don’t ship to this country yet.',
  'Code postal français à 5 chiffres requis.': 'A 5-digit French postcode is required.',
  'Aucune donnée à mettre à jour': 'Nothing to update',
  'Erreur de connexion': 'Sign-in error',
  'Erreur d’inscription': 'Registration error',
  'Le service est momentanément indisponible.': 'The service is temporarily unavailable.',
  'La connexion prend trop de temps. Vérifiez votre connexion et réessayez. Votre panier est conservé.': 'The connection is taking too long. Check your connection and try again. Your bag has been saved.',
  'Le lien de paiement est indisponible. Votre panier a été conservé.': 'The payment link is unavailable. Your bag has been saved.',
  'Le paiement est indisponible. Votre panier a été conservé.': 'Payment is unavailable. Your bag has been saved.',
  'Activez le stockage de session de votre navigateur pour préparer le paiement en toute sécurité.': 'Please enable session storage in your browser so payment can be prepared safely.',
  'Impossible de vérifier le paiement précédent. Réessayez la vérification avant de payer.': 'We couldn’t check your previous payment. Please try the check again before paying.',
};

const PASSWORD_PARTS = { 'une minuscule': 'a lowercase letter', 'une majuscule': 'an uppercase letter', 'un chiffre': 'a number', 'un symbole': 'a symbol' };

// Les messages citent le nom français de la pièce.
const englishName = name => {
  const character = CHARACTER_FILTERS.find(entry => entry.name === name);
  return (character && CHARACTER_NAMES_EN[character.slug]) || name;
};

const PATTERNS = [
  [/^Le mot de passe doit contenir (.+)$/, (_, parts) => `Your password must contain ${parts.split(', ').map(part => PASSWORD_PARTS[part] || part).join(', ')}`],
  [/^(.+) vient d'être adoptée — il n'en existait qu'une\.$/, (_, name) => `${englishName(name)} has just been adopted — there was only one.`],
  [/^(.+) est une pièce unique : quantité limitée à 1\.$/, (_, name) => `${englishName(name)} is one of a kind: quantity limited to 1.`],
  [/^(.+) est temporairement indisponible ou réservée pour un paiement\.$/, (_, name) => `${englishName(name)} is temporarily unavailable or reserved for a payment.`],
  [/^Stock insuffisant pour (.+)$/, (_, name) => `Not enough stock for ${englishName(name)}`],
  [/^Produit introuvable: (.+)$/, () => 'Product not found'],
  [/^Nous livrons pour l'instant : (.+)$/, (_, countries) => `For now we only ship to: ${countries}`],
];

export function translateMessage(message, locale) {
  if (locale !== 'en' || typeof message !== 'string' || !message) return message;
  if (EXACT[message]) return EXACT[message];
  for (const [pattern, replace] of PATTERNS) {
    if (pattern.test(message)) return message.replace(pattern, replace);
  }
  return message;
}

// Pour le code hors composants (utilitaires de paiement, contexte d'authentification).
export function currentLocale() {
  return typeof window === 'undefined' ? 'fr' : localeFromPath(window.location.pathname);
}

export const localMessage = message => translateMessage(message, currentLocale());
